(function () {
  async function getShopifyCartId() {
    const cookieMatch = `; ${document.cookie}`.match(/;\s*cart=([^;]+)/);
    if (cookieMatch) {
      return cookieMatch[1].slice(-10);
    }

    const response = await fetch("/cart.js", {
      headers: {
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not load the current cart");
    }

    const cart = await response.json();
    return cart.token ? cart.token.slice(-10) : null;
  }

  async function parseJsonResponse(response) {
    const text = await response.text();

    if (!text) {
      return {};
    }

    try {
      return JSON.parse(text);
    } catch (_error) {
      return { error: text };
    }
  }

  async function loadCart() {
    const response = await fetch("/cart.js", {
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    });

    if (!response.ok) {
      throw new Error("Could not load the current cart");
    }

    return response.json();
  }

  function backstoryLineForDraftItem(cart, draftOrderItemId) {
    return (cart.items || []).find(
      (item) =>
        String(item.properties?._DraftOrderItemID) ===
          String(draftOrderItemId) &&
        (item.sku === "BACKSTORY-LABEL" ||
          Boolean(item.properties?._GiftOptionProductableType)),
    );
  }

  async function removeCurrentBackstoryLine(draftOrderItemId) {
    for (let attempt = 1; attempt <= 5; attempt += 1) {
      const cart = await loadCart();
      const currentLine = backstoryLineForDraftItem(cart, draftOrderItemId);
      if (!currentLine) return;

      const response = await fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ id: currentLine.key, quantity: 0 }),
      });
      const payload = await parseJsonResponse(response);

      if (!response.ok) {
        throw new Error(
          payload.description ||
            payload.error ||
            "Could not remove the backstory from your cart",
        );
      }
    }

    throw new Error("Could not verify that the backstory was removed");
  }

  async function removeFramefoxBackstory(button) {
    if (!button || button.dataset.removing === "true") {
      return;
    }

    button.dataset.removing = "true";
    button.disabled = true;
    button.setAttribute("aria-busy", "true");

    const originalLabel = button.textContent;
    button.textContent = "Removing";

    try {
      const shopifyCartId = await getShopifyCartId();

      if (!shopifyCartId) {
        throw new Error("Could not determine the current Shopify cart");
      }

      await removeCurrentBackstoryLine(button.dataset.draftOrderItemId);

      const clearResponse = await fetch(
        `/apps/frame/draft_order_items/${button.dataset.draftOrderItemId}/remove_backstory`,
        {
          method: "POST",
          credentials: "same-origin",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            shopify_cart_id: shopifyCartId,
          }),
        },
      );

      const clearPayload = await parseJsonResponse(clearResponse);

      if (!clearResponse.ok) {
        throw new Error(
          clearPayload.error ||
            "Could not clear the backstory from the draft order item",
        );
      }

      window.location.reload();
    } catch (error) {
      console.error("Error removing Framefox backstory:", error);
      alert(error.message || "Failed to remove backstory. Please try again.");
    } finally {
      button.dataset.removing = "false";
      button.disabled = false;
      button.removeAttribute("aria-busy");
      button.textContent = originalLabel;
    }
  }

  window.removeFramefoxBackstory = removeFramefoxBackstory;
})();
